import React, { useState } from 'react';
import axios from 'axios';

const AccountDeletionPage = () => {
    const [deviceId, setDeviceId] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        if (!deviceId) {
            return setMessage('Please provide your device ID.');
        }

        try {
            setLoading(true);
            const response = await axios.delete(
                'https://ai-voice-changer-806c2d387e06.herokuapp.com/api/user/user-delete',
                {
                    data: { deviceId },
                }
            );
            setMessage(
                response.data.message ||
                response.data?.msg ||
                'Your Funo AI account has been deleted successfully.'
            );
        } catch (error) {
            const msg =
                error.response?.data?.message ||
                error.response?.data?.msg ||
                error.response?.data?.error ||
                'Something went wrong.';
            setMessage(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-xl mx-auto px-6 py-12 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-200">
            <h1 className="text-3xl font-bold mb-4">Delete Your Funo AI Account</h1>
            <p className="mb-6">
                This page is for deleting your <b>Funo AI</b> account. Please enter your device ID below to permanently delete your account and all associated data from Funo AI. Your data will be erased and cannot be recovered after deletion.
            </p>

            <div className="space-y-4">
                <input
                    type="text"
                    placeholder="Device ID"
                    value={deviceId}
                    onChange={(e) => setDeviceId(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded"
                />
                <button
                    onClick={handleDelete}
                    disabled={loading}
                    className="w-full py-2 px-4 bg-red-600 text-white font-bold rounded hover:bg-red-700"
                >
                    {loading ? 'Deleting...' : 'Delete Funo AI Account'}
                </button>
                {message && (
                    <p className="mt-4 text-center text-sm text-red-500">{message}</p>
                )}
            </div>
        </div>
    );
};

export default AccountDeletionPage;
